import { Component } from '@angular/core';

@Component({
  selector: 'app-map-it-tab',
  templateUrl: './map-it-tab.component.html',
  styleUrls: ['./map-it-tab.component.scss']
})
export class MapItTabComponent {

}
